module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "widget-license-flash-message"
    }
  }, [(_vm.license_message) ? [_vm._m(0)] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flash-message message-warning"
  }, [_c('i', {
    staticClass: "icon-error fa fa-warning"
  }), _vm._v("\n      License Message\n      "), _c('div', {
    staticClass: "flash-message-close"
  }, [_vm._v("x")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9a039ca4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dash/widgets/WidgetLicenseFlashMessage.vue
// module id = 3934
// module chunks = 1